import { Theme, createStyles } from '@material-ui/core';
import { StyleRules } from '@material-ui/core/styles/withStyles';

const styles = (theme: Theme): StyleRules<string, {}> => createStyles({
  root: {
    height: '100vh',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
  },
  detailsPanel: {
    display: 'flex',
    overflowY: 'scroll',
  },
  body: {
    margin: `${theme.spacing(1)}px auto`,
    display: 'flex',
    flexDirection: 'column',
  },
});

export default styles;
